import {PaymentProvider} from "../PaymentProvider.ts";
import EvergentForm from "../../components/Evergent/EvergentForm/EvergentForm"
import RegistrationFlow from "../../components/Evergent/PickProgram/FlowElements/RegistrationFlow"
import MigrationFlow from "../../components/Evergent/PickProgram/FlowElements/MigrationFlow"
import UnsubscribeHandle from "../../components/Evergent/Unsubscribe/Unsubscribe"

export class EvergentPaymentProvider implements PaymentProvider {
    paymentForm= "/CartPage";
    PaymentProviderComponent= <EvergentForm />
    RegistrationFlow= RegistrationFlow
    MigrationFlow= MigrationFlow;
    OnUnsubscribeHandle= UnsubscribeHandle
    UnsubscribeComponent= <EvergentForm />
}